import React, { useEffect, useState } from "react";
import Nav from "../component/Nav";
import { useParams } from "react-router-dom";
import AllProduct from "../component/AllProduct";
import Footer from "../component/Footer";
import Tittle from "../component/Tittle";
import Loader from "../component/Loader";

function Search() {
  const [items, setItems] = useState();
  const [loading, setLoading] = useState(false)
  const params = useParams();
  useEffect(() => {
    setLoading(true)
    fetch(`${process.env.REACT_APP_API_URL}/search?q=${params.s}`)
      .then((res) => res.json())
      .then((data) => setItems(data))
      .catch((err) => console.log(err))
      .finally(()=>setLoading(false))
  }, [params]);
  return (
    <div>
        <Loader loading={loading}/>
      <Nav />
      <Tittle text={`Search result for: ${params.s}`} />
      <AllProduct items={items} />
      {!items?.product?.length && <p style={{
        textAlign: "center",
        color: "grey",
        marginBottom: "20px"
      }}>No result for {params.s}</p>}
      <Footer />
    </div>
  );
}

export default Search;
